import { useRef, useCallback } from "react";
import { IDocument } from "../@types/document";
import { DocCard } from "./DocCard";
import Loader from "./Loader";

interface DocsListProp {
    docs: IDocument[];
    isLoadingDocs: boolean;
    onLoadDocs: () => void;
    hasMore: boolean;
}

export default function DocsList({ docs, isLoadingDocs, onLoadDocs, hasMore }: DocsListProp) {
    const observer = useRef<IntersectionObserver | null>(null);

    const lastDocElementRef = useCallback((node: HTMLDivElement) => {
        if (isLoadingDocs) return;

        if (observer.current) {
            observer.current.disconnect();
        }

        observer.current = new IntersectionObserver(entries => {
            const entry = entries[0];
            if (entry.isIntersecting && hasMore) {
                onLoadDocs();
            }
        }, { threshold: 1 });

        if (node) {
            observer.current.observe(node);
        }
    }, [isLoadingDocs, hasMore]);

    return (
        <div className="flex flex-col w-full items-center gap-[16px]">
            {docs.map((doc, index) => (
                <DocCard
                    doc={doc}
                    key={doc._id}
                    ref={index === docs.length - 1 ? lastDocElementRef : undefined}
                />
            ))}
            {isLoadingDocs && (
                <div className="w-full py-4">
                    <Loader />
                </div>
            )}
        </div>
    )
}